/** @jsxImportSource @emotion/react */
'use memo'
import css from '@emotion/css/macro'
import { WalletOutlined } from '@ant-design/icons'
import colors from '@sportninja/common/constants/appColors'
import { formatCurrency } from '@sportninja/common/utils/utils'
import dayjs from 'dayjs'
import IndicatorCard from 'src/components/ts-components/IndicatorCard'
import { calculatePastDues } from '../../FinancialList'
import { useBillingContext } from '../context/BillingContext'

const BillingCards = () => {
  const { billingItems, currencyCode } = useBillingContext()

  const totalPaid = billingItems
    .filter((el) => el.paid)
    .reduce((acc, el) => acc + el.display_subtotal, 0)

  const totalOutstanding = billingItems
    .filter((el) => !el.paid || el.refunded)
    .reduce((acc, el) => {
      if (el.refunded && el.refund_subtotal < el.subtotal) {
        return acc + (el.subtotal - el.refund_subtotal)
      }
      return acc + el.subtotal
    }, 0)

  const totalAll = billingItems.reduce((acc, el) => acc + el.subtotal, 0)

  const nextPayment = billingItems.find((el) => !el.paid)

  const pastDue = calculatePastDues(billingItems)

  const iconNode = (
    <WalletOutlined
      css={css`
        font-size: 32px;
        color: ${colors.NEUTRAL_100};
        flex-shrink: 0;
      `}
    />
  )

  if (billingItems.length === 0) {
    return null
  }

  return (
    <div
      css={css`
        display: flex;
        align-items: flex-start;
        gap: 16px;
        flex-shrink: 0;
        width: 100%;

        @media (max-width: 768px) {
          flex-direction: column;
          padding: 0 16px;
        }
      `}
    >
      <IndicatorCard
        icon={iconNode}
        title='Total Paid'
        value={`${formatCurrency(totalPaid, currencyCode)} / ${formatCurrency(
          totalAll,
          currencyCode
        )}`}
        subtitle={`Total Outstanding: ${formatCurrency(
          totalOutstanding,
          currencyCode
        )}`}
        hideSmallIndicator
      />
      {nextPayment && (
        <IndicatorCard
          icon={iconNode}
          title='Next Payment'
          value={formatCurrency(nextPayment.subtotal, currencyCode)}
          subtitle={dayjs(nextPayment.due_date).format('MMMM DD, YYYY')}
          hideSmallIndicator
        />
      )}
      <IndicatorCard
        icon={iconNode}
        title='Total Past Due'
        value={formatCurrency(pastDue, currencyCode)}
        subtitle=''
        hideSmallIndicator
        hideSubtitle
      />
    </div>
  )
}

export default BillingCards
